import { render, staticRenderFns } from "./RentalOwners.vue?vue&type=template&id=5c34b306&scoped=true"
import script from "./RentalOwners.vue?vue&type=script&lang=js"
export * from "./RentalOwners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c34b306",
  null
  
)

export default component.exports